import { FC, Fragment } from "preact/compat";
import { Transition } from "@headlessui/react";
import { useSignalEffect } from "@preact/signals";
import { useApp } from "~/core/store";
import { updateUrlParams } from "~/utils";
import TaskList from "./TaskList";
import CloseIcon from "@material-design-icons/svg/outlined/close.svg";

const IssueTracker: FC = () => {
    const {
        dialog: { issueTracker },
    } = useApp();

    useSignalEffect(() => {
        updateUrlParams({
            "issue-tracker": issueTracker.show.value ? "true" : null,
        });
    });

    // @TODO: make it accessible

    return (
        <Transition show={issueTracker.show.value}>
            <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
            >
                <div className="fixed left-[50px] top-[50px] right-0 bottom-0 z-[80] backdrop-blur" />
            </Transition.Child>
            <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-x-full"
                enterTo="opacity-100 translate-x-0"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-x-0"
                leaveTo="opacity-0 translate-x-full"
            >
                <div
                    role="dialog"
                    aria-modal="true"
                    className="fixed left-[260px] top-[50px] right-0 bottom-0 z-[90] bg-white border-l-2 border-gray-200"
                >
                    <div className="relative">
                        <div className="absolute -left-16 top-8">
                            <button
                                type="button"
                                className="text-gray-500 hover:text-red-500 p-2 rounded-full bg-white border border-gray-200"
                                onClick={() =>
                                    (issueTracker.show.value = false)
                                }
                            >
                                <CloseIcon
                                    width="24"
                                    height="24"
                                    className="fill-current"
                                />
                            </button>
                        </div>
                        <TaskList />
                    </div>
                </div>
            </Transition.Child>
        </Transition>
    );
};

export default IssueTracker;
